<script setup lang="ts">
import { t } from '@fondof-ui/lib/translations'
import { useLocationStore } from '@global-store/stores/location'

import {
  AffenzahnIcon,
  AlviIcon,
  ErgobagColorlessIcon,
  SatchIcon,
} from '@fond-of/fondof-icons'

const props = defineProps<{
  utmParamsFooter?: string
}>()

const locationStore = useLocationStore()
</script>
<template>
  <div
    class="mb-15 row-start-4 md:col-start-[third-col] md:row-start-[first-row] md:mb-0"
  >
    <h4 class="headline-style mb-6 text-base">
      {{ t('footer.ourBrands') }}
    </h4>

    <ul class="flex flex-wrap items-center gap-6">
      <li class="flex h-7 w-auto items-center justify-center">
        <a
          :href="`https://alvi.de${props.utmParamsFooter || ''}`"
          target="_blank"
          gtm-data-attr="button_crossbrand_footer"
          gtm-data-label="alvi"
          class="flex h-full items-center"
        >
          <AlviIcon class="h-full w-auto overflow-visible pb-1" />
        </a>
      </li>
      <li class="flex h-10 w-auto items-center justify-center md:h-9">
        <a
          :href="`https://www.affenzahn.com${props.utmParamsFooter || ''}`"
          target="_blank"
          gtm-data-attr="button_crossbrand_footer"
          gtm-data-label="affenzahn"
          class="flex h-full items-center"
        >
          <AffenzahnIcon class="h-full w-auto overflow-visible" />
        </a>
      </li>
      <li class="flex h-7 w-auto items-center justify-center md:h-6">
        <a
          :href="`https://www.ergobag.${locationStore.currentLocale === 'de' ? 'de' : 'com/' + locationStore.currentLocale}${props.utmParamsFooter || ''}`"
          target="_blank"
          gtm-data-attr="button_crossbrand_footer"
          gtm-data-label="ergobag"
          class="flex h-full items-center"
        >
          <ErgobagColorlessIcon class="h-full w-auto overflow-visible" />
        </a>
      </li>
      <li class="flex h-9 w-auto items-center justify-center md:h-8">
        <a
          :href="`https://www.satch.com/${locationStore.currentLocale}${props.utmParamsFooter || ''}`"
          target="_blank"
          gtm-data-attr="button_crossbrand_footer"
          gtm-data-label="satch"
          class="flex h-full items-center"
        >
          <SatchIcon class="h-full w-auto overflow-visible" />
        </a>
      </li>
      <slot :current-locale="locationStore.currentLocale" />
    </ul>
  </div>
</template>
